import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  languageTiers: [],
  templanguageTiers: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  current_page: 1,
  per_page: PAGELENGTH,
  last_page: 1
}

export const languageTiersSlice = createSlice({
  name: 'language Tiers',
  initialState: initialState,
  reducers: {
    setLanguageTier: (state, { payload }) => {
      state.languageTiers = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setLanguageTiers: (state, { payload }) => {
      state.languageTiers = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setTemplanguageTiers: (state, { payload }) => {
      state.templanguageTiers = payload?.data;
    },
    setMoreLanguages: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeLanguageTiers: (state, { payload }) => {
      state.error = payload
    },
    clearAllLanguage: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const addLanguageTiers = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.addLanguageTiers(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const updateLanguageTiers = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateLanguageTiers(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const removeLanguageTiers = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeLanguageTiers(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const fetchLanguagesTiers = (page, params, disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchLanguagesTiers(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setLanguageTiers(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setLanguageTiers(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}

export const fetchTemplateLanguagesTiers = (page, params, disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchTemplateLanguagesTiers(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data;
        } else {
          dispatch(setTemplanguageTiers(result.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data;
        } else {
          dispatch(setTemplanguageTiers(result.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}

export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, 'language-tiers')
    if (json.status >= 200 && json.status < 300) {
    } else if (json.status == 422) {
      dispatch(setError(json.data))
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const removeMultipleLanguagesTiers = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleLanguagesTiers(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const importLanguageTiers = (formData, callback) => async (dispatch) => {
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.importLanguageTiers(formData)
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data?.message || 'Language tiers imported successfully.')
      dispatch(fetchLanguagesTiers())
    } else if (json.status === 422) {
      dispatch(setError(json.data))
      callback(false, json.data?.message || 'Validation failed.')
    } else {
      callback(false, json.data?.message || 'Import failed.')
    }
  } catch (error) {
    console.log(error)
    callback(false, 'Import failed.')
  }
  dispatch(setLoader(false))
}

export const { setLanguageTier, setLanguageTiers,setTemplanguageTiers, clearAllLanguageTier, setLoader, setError, setMoreLanguagesTiers } = languageTiersSlice.actions


export default languageTiersSlice.reducer
export const languageTierSelector = state => state.languageTier


